<template lang="pug">
.bloco-situacao-monitoramento-agricola(:style="divergencia ? 'border: solid #f88342' : 'border: none'")
    .bloco-situacao-monitoramento-agricola__titulo
        .bloco-situacao-monitoramento-agricola__titulo-interno
            span {{ titulo }}
        .bloco-situacao-monitoramento-agricola__titulo-icone
            i(:class='iconeDivergencia')

    .bloco-situacao-monitoramento-agricola__interno
        .bloco-situacao-monitoramento-agricola__interno-alinhamento
            span.bloco-situacao-monitoramento-agricola__interno-icone
                i(:class='icone')
            span.bloco-situacao-monitoramento-agricola__interno-subtitulo {{ descricaoEsquerda }}
            span.bloco-situacao-monitoramento-agricola__interno-negrito {{ valorEsquerdo }}
        .bloco-situacao-monitoramento-agricola__interno-alinhamento
            span
                i(:class='icone')
            span.bloco-situacao-monitoramento-agricola__interno-subtitulo {{ descricaoDireita }}
            span.bloco-situacao-monitoramento-agricola__interno-negrito {{ valorDireito }}
</template>

<script>
export default {
    name: 'BlocoSituacaoMonitoramentoAgricola',
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        descricaoEsquerda: {
            type: String,
            default: () => ''
        },
        valorEsquerdo: {
            type: String,
            default: () => ''
        },
        descricaoDireita: {
            type: String,
            default: () => ''
        },
        valorDireito: {
            type: String,
            default: () => ''
        },
        icone: {
            type: String,
            default: () => ''
        },
        iconeDivergencia: {
            type: String,
            default: () => 'mdi mdi-check-circle-outline'
        },
        divergencia: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.bloco-situacao-monitoramento-agricola {
    min-width: 24%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    min-height: 89px;
    align-items: center;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 10px 20px;
    flex-direction: column;
    .bloco-situacao-monitoramento-agricola__titulo {
        display: flex;
        justify-content: space-between;
        align-self: normal;
    }
    .bloco-situacao-monitoramento-agricola__titulo-interno {
        width: 90%;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        margin-left: 31px;
        a.el-link {
            font-size: 20px;
            margin: -2px 0 0 5px;
        }
        a.el-link:not(.is-disabled):hover {
            color: var(--secondary-two);
        }
        a.el-link.is-disabled:hover {
            color: #c0c4cc;
        }
    }
    .bloco-situacao-monitoramento-agricola__titulo-icone {
        width: 10%;
        font-size: 22px;
        display: flex;
        justify-content: flex-end;
        .mdi-alert-outline {
            color: #f88342;
        }
        .mdi-check-circle-outline {
            color: var(--secondary-two);
        }
    }
    .bloco-situacao-monitoramento-agricola__interno {
        position: relative;
        bottom: 6px;
        margin-right: 3px;
        display: flex;
        text-align: center;
        justify-content: space-between;
        width: 90%;
        .lyra-icon::before {
            content: '';
            width: 41px !important;
            height: 41px !important;
            margin-bottom: 13px;
            background-color: var(--primary) !important;
        }
        .mdi::before {
            font-size: 50px !important;
            color: var(--primary) !important;
        }
        .bloco-situacao-monitoramento-agricola__interno-alinhamento {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
    .bloco-situacao-monitoramento-agricola__interno-dados {
        flex-wrap: wrap;
        font-size: 20px;
    }
    span {
        padding: 3px;
        &.bloco-situacao-monitoramento-agricola__interno-subtitulo {
            max-width: 184px;
            font-weight: 500;
            padding: 0px;
        }

        &.bloco-situacao-monitoramento-agricola__interno-negrito {
            padding: 0px !important;
            font-weight: 600;
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
</style>
